import { forwardRef } from "react";

import { useCurrentAccount } from "@/providers/account";
import { Link, LinkProps } from "@tanstack/react-location";

/** Links within the current workspace. Use `LinkToWorkspace` to point at a different one. */
export const LinkWithSlug = forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => {
    const { slug } = useCurrentAccount();

    const prependSlug = (to: string) => {
      return `/${slug}${to.startsWith("/") ? to : `/${to}`}`;
    };

    return (
      <Link
        _ref={ref}
        {...props}
        to={typeof props.to === "string" ? prependSlug(props.to) : props.to}
      />
    );
  },
);
